/*! Prefetch product-card secondary images before hover (desktop only). */
(function () {
  if (typeof window === 'undefined') return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function markReady(img) {
    if (!img) return;
    img.dataset.hoverLoaded = '1';
    img.classList.add('is-hover-ready');
    img.removeAttribute('data-hover-src');
    img.removeAttribute('data-hover-srcset');
  }

  function loadHoverImage(img) {
    if (!img || img.dataset.hoverLoaded === '1') return;
    var src = img.getAttribute('data-hover-src');
    var srcset = img.getAttribute('data-hover-srcset');
    if (!src && !srcset) return;

    var done = function () {
      markReady(img);
    };

    if (srcset) img.srcset = srcset;
    if (src) img.src = src;

    if (img.decode) {
      img.decode().then(done).catch(done);
    } else if (img.complete) {
      done();
    } else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  }

  function loadIn(container) {
    if (!container) return;
    container.querySelectorAll('img[data-hover-src], img[data-hover-srcset]').forEach(loadHoverImage);
  }

  // Prefetch when card approaches viewport so hover is instant
  if (canHover && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadIn(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    var observeAll = function () {
      document.querySelectorAll('.media--hover-effect, .resource-card__media').forEach(function (el) {
        if (el.querySelector('img[data-hover-src], img[data-hover-srcset]')) io.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }

    // Theme section re-renders / infinite scroll
    document.addEventListener('shopify:section:load', observeAll);
  }

  // Fallback: still load immediately on pointerenter/focus
  var onEnter = function (event) {
    var media =
      event.target.closest &&
      event.target.closest('.media--hover-effect, .card__media, .resource-card__media');
    if (!media) return;
    loadIn(media);
  };

  document.addEventListener('pointerenter', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
})();
